// src/hooks/usePageTitle.ts
import { useEffect } from 'react';

const APP_NAME = 'OSKI HRM';

/**
 * Sets document.title (the browser tab text) for the current page.
 * Pass undefined/null/empty string to fall back to the base app name.
 */
export function usePageTitle(title?: string | null) {
  useEffect(() => {
    document.title = title ? `${title}` : APP_NAME;
  }, [title]);
}
